var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_806_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.267,
    height: 63.61,
    viewBox: "0 0 66.267 63.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_386_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    d: "M66.139,45.128A26.123,26.123,0,0,0,45.825,22.221V18.933a4.4,4.4,0,0,0-1.062-8.671H35.444a4.4,4.4,0,0,0-1.062,8.671v3.3a25.988,25.988,0,0,0-12.746,7.011,26.27,26.27,0,0,0-2.2,2.494c-.032,0-.065,0-.1,0H10.117a1.294,1.294,0,1,0,0,2.589h7.56a25.946,25.946,0,0,0-2.3,4.975H1.294a1.294,1.294,0,0,0,0,2.589H14.649a26.316,26.316,0,0,0-.642,4.975H8.283a1.294,1.294,0,1,0,0,2.589h5.765a26.277,26.277,0,0,0,.808,4.975H6.471a1.294,1.294,0,1,0,0,2.589h9.211A26.141,26.141,0,0,0,37.539,73.746q1.283.127,2.565.126a26.208,26.208,0,0,0,14.268-4.217,1.294,1.294,0,0,0-1.413-2.169A23.556,23.556,0,1,1,59.9,60.54a1.294,1.294,0,1,0,2.171,1.41A26.228,26.228,0,0,0,66.139,45.128ZM33.632,14.663a1.814,1.814,0,0,1,1.812-1.812h9.319a1.812,1.812,0,1,1,0,3.624H35.444A1.814,1.814,0,0,1,33.632,14.663Zm3.338,7.123V19.063h6.266v2.718A26.372,26.372,0,0,0,36.97,21.786Z",
    transform: "translate(0 -10.262)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    d: "M437.064,425.5a1.295,1.295,0,1,0,.915.379A1.3,1.3,0,0,0,437.064,425.5Z",
    transform: "translate(-379.369 -371.756)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    d: "M174.95,144.609a20.078,20.078,0,1,0,20.078,20.078A20.1,20.1,0,0,0,174.95,144.609Zm0,37.568a17.49,17.49,0,1,1,17.49-17.49A17.509,17.509,0,0,1,174.95,182.177Z",
    transform: "translate(-134.827 -127.221)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    d: "M272.079,219.79l-6.411,6.41a4.012,4.012,0,0,0-3.553,0l-2.869-2.869a1.294,1.294,0,0,0-1.831,1.83l2.869,2.869a4.022,4.022,0,1,0,7.214,0l6.222-6.222h0l.188-.188a1.294,1.294,0,0,0-1.83-1.83Zm-8.187,11.451a1.433,1.433,0,1,1,1.433-1.433A1.435,1.435,0,0,1,263.891,231.241Z",
    transform: "translate(-223.768 -192.341)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    d: "M400.148,289.86h-1.2a1.294,1.294,0,0,0,0,2.589h1.2a1.294,1.294,0,0,0,0-2.589Z",
    transform: "translate(-346.187 -253.672)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    d: "M195.575,289.616h-1.2a1.294,1.294,0,0,0,0,2.589h1.2a1.294,1.294,0,0,0,0-2.589Z",
    transform: "translate(-168.092 -253.459)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    d: "M301.417,186.607a1.294,1.294,0,0,0,1.294-1.294v-1.2a1.294,1.294,0,0,0-2.589,0v1.2A1.294,1.294,0,0,0,301.417,186.607Z",
    transform: "translate(-261.278 -160.485)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_424_",
    d: "M301.173,387.393a1.294,1.294,0,0,0-1.294,1.294v1.2a1.294,1.294,0,0,0,2.589,0v-1.2A1.294,1.294,0,0,0,301.173,387.393Z",
    transform: "translate(-261.066 -338.581)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    d: "M1.294,351.44a1.294,1.294,0,1,0,.915,2.209,1.294,1.294,0,0,0-.915-2.209Z",
    transform: "translate(0 -307.282)",
    fill: "#e51b26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.e4ca6c1ca222f0bba9d0124ebedc3b7b.svg";
export { ForwardRef as ReactComponent };